import { useAtom } from "jotai";

import { GoToPortalButton } from "@/components/Layout/GoToPortalButton/GoToPortalButton";
import { Header } from "@/components/Layout/Header/Header";
import { LogoutButton } from "@/components/Layout/LogoutButton/LogoutButton";
import { isAnonymousUserAtom } from "@/utils/atoms";

/**
 * OnboardingHeader component
 *
 * Displays appropriate navigation button in the header based on authentication status:
 * - For anonymous customers: Shows portal navigation button
 * - For authenticated customers: Shows logout button
 */
export const OnboardingHeader = () => {
  const [isAnonymousUser] = useAtom(isAnonymousUserAtom);

  return (
    <Header>{isAnonymousUser ? <GoToPortalButton /> : <LogoutButton />}</Header>
  );
};
